//@ts-nocheck
import Pills from '@wearesection/bandai-react-components/atoms/Pills';
import Typography from '@wearesection/bandai-react-components/atoms/Typography';
import Popup from '@wearesection/bandai-react-components/molecules/Popup';
import {Box} from '@mui/material';
import {useRouter} from 'next/router';
import React, {useEffect, useState} from 'react';
import {IAgeRatingPopup} from './types';

type NewIAgeRatingPopup = IAgeRatingPopup & {urlBack?: string};
const AgeRatingPopupOrganisms: React.FC<NewIAgeRatingPopup> = props => {
  const {title, description, atLeastAgeLabel, notYetAgeLabel, isOpen = false} = props;
  const [afterClick, setAfterClick] = useState<boolean>(false);
  const router = useRouter();

  const handleClosed = (bool: boolean) => {
    document.body.classList.remove('disable-scroll');
    if (bool && window) {
      if (typeof router?.back === 'function' && window?.history?.length > 1) {
        router?.back();
        return;
      }
      if (props?.urlBack) {
        window.location.href = props?.urlBack;
      } else {
        window.location.href = '/' + router?.locale + '/games';
      }
    }
  };

  useEffect(() => {
    // setAfterClick(isOpen);
    const showPopup = setTimeout(() => setAfterClick(isOpen), 100);
    return () => {
      clearTimeout(showPopup);
    };
  }, [isOpen]);

  useEffect(() => {
    let timeOut: any = 0;
    if (typeof window !== 'undefined') {
      timeOut = setTimeout(() => {
        if (!afterClick) {
          document.body.classList.remove('disable-scroll');
        } else {
          document.body.classList.add('disable-scroll');
        }
      }, 1500);
    }
    return () => {
      window.clearTimeout(timeOut);
    };
  }, [afterClick]);

  return (
    <Popup
      maxWidth="579px"
      disableClickBackdrop
      sxPopup={{
        outline: 'none',
        '& #box-modal-sa': {
          padding: {
            md: '96px 52px 96px 52px',
            xs: '64px 28px 64px 28px',
          },
          '& .MuiContainer-root': {
            padding: '0px',
          },
        },
      }}
      isOpen={afterClick}
      isClosed={handleClosed}
      isHideIcon
    >
      <Box
        sx={{
          textAlign: 'center',
        }}
      >
        <Typography
          textTransform={''}
          variant="h4"
          sx={{
            color: '#1E1E1E',
            maxWidth: {
              xs: '202px',
              md: '100%',
            },
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          {title}
        </Typography>
        <Typography
          textTransform={''}
          variant="p8"
          sx={{
            color: '#737373',
            maxWidth: {
              xs: '212px',
              md: '100%',
            },
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: '16px',
          }}
        >
          {description}
        </Typography>

        <Box
          sx={{
            textAlign: 'center',
            margin: '32px auto 0',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            width: {
              xs: '170px',
              md: '192px',
            },
            '& div': {
              width: '100%',
            },
          }}
        >
          <Box
            onClick={() => setAfterClick(false)}
            sx={{
              width: '100%',
            }}
          >
            <Pills label={atLeastAgeLabel} />
          </Box>
          <Box
            onClick={() => handleClosed(true)}
            sx={{
              width: '100%',
            }}
          >
            <Pills label={notYetAgeLabel} />
          </Box>
        </Box>
      </Box>
    </Popup>
  );
};

export default AgeRatingPopupOrganisms;
